module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki14_pc-504fcb3747b33f51ec81774624305dd5.jpg";